// ─── Supabase client ──────────────────────────────────────────────────────────
// Inizializzato una volta all'avvio dell'app.
// Se le env var non sono settate, l'app gira in "modalità demo locale"
// (niente autenticazione, niente crediti, tutto in localStorage come prima).
// Questo permette lo sviluppo offline e il fallback se il backend è down.

import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL      = process.env.REACT_APP_SUPABASE_URL || '';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

export const SUPABASE_ENABLED = !!(SUPABASE_URL && SUPABASE_ANON_KEY);

if (!SUPABASE_ENABLED) {
  // eslint-disable-next-line no-console
  console.warn(
    '⚠️ Supabase non configurato. L\'app gira in modalità demo locale.\n' +
    '   Aggiungi REACT_APP_SUPABASE_URL e REACT_APP_SUPABASE_ANON_KEY al file .env per abilitare auth e crediti.'
  );
}

export const supabase = SUPABASE_ENABLED
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;
